module.exports = __webpack_public_path__ + "static/media/2.ac79c333.png";